import axios from 'axios'

class Utility {
    el = document.querySelector('meta[name="csrf-token"]')
    token = (this.el != null) ? this.el.getAttribute('content') : ''

    apiClient = axios.create({

        headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': this.token
        }
    })

    catchError(error) {
        alert(error)
        console.log(error)
    }

}

export default new Utility()
